module.exports = __webpack_public_path__ + "static/media/6-5.aed2b49f.mp3";